import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M315.2 505.6l440-440c8-8 8-19.2 0-27.2v0c-8-8-19.2-8-27.2 0l-460.8 459.2c-8 8-8 19.2 0 27.2v0c0 0 1.6 1.6 1.6 1.6l459.2 459.2c8 8 19.2 8 27.2 0v0c8-8 8-19.2 0-27.2l-440-440c-3.2-3.2-3.2-9.6 0-12.8z\" p-id=\"1091\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol